import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { localize } from 'react-localize-redux';
import moment from 'moment';
import { translate } from 'react-i18next';
import i18n from '../translations/i18n';

const PlainField = styled.div`
  padding-top: 40px;
  padding-bottom: 16px;
  line-height: 20px;
`;

const propTypes = {
  values: PropTypes.any,
  t: PropTypes.func,
};

const defaultProps = {};

const PacketboxStatusFields = (props) => {
  const { values } = props;

  if (!values) {
    return null;
  }

  const status = values.is_active ? props.t('active') : props.t('inactive');

  let tan = '-';
  let activationPinValidFrom = '-';
  let activationPinValidTo = '-';
  let masterPin = '-';

  if (!values.is_active && values.activation_pin_date && values.activation_pin) {
    tan = values.activation_pin;
    const activationPinDate = moment(values.activation_pin_date);
    activationPinValidFrom = activationPinDate.format('DD.MM.YYYY HH:mm:ss');
    activationPinValidTo = activationPinDate.add(14, 'days').format('DD.MM.YYYY HH:mm:ss');
  }

  if (!!values.masterPin) {
    masterPin = values.masterPin
  }

  return (
    <PlainField>
      {props.t('state')}: {status} <br />
      {props.t('activation_tan')}: {tan} <br />
      {props.t('activation_tan_created_at')}: {activationPinValidFrom} <br />
      {props.t('activation_tan_valid_until')}: {activationPinValidTo} <br />
      {props.t('master_pin')}: {masterPin}
    </PlainField>
  );
};

PacketboxStatusFields.propTypes = propTypes;
PacketboxStatusFields.defaultProps = defaultProps;

const extended = translate(['translations'], { i18n })(PacketboxStatusFields);
export default localize(extended, 'locale');



// WEBPACK FOOTER //
// ./src/components/PacketboxStatusFields.js